import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import TODAY_ORDERS from "./../assets/images/todayOrders.svg"
import TODAY_ORDERS_ACTIVE from "./../assets/images/todayOrdersActive.svg"
import ORDERS_REPORTS from "./../assets/images/reports.svg"
import ORDERS_REPORTS_ACTIVE from "./../assets/images/reportsActive.svg"
import FINANCIAL_REPORTS from "./../assets/images/financeReports.svg"
import FINANCIAL_REPORTS_ACTIVE from "./../assets/images/financeReportsActive.svg"
import PROFILE from "./../assets/images/profile.svg"
import PROFILE_ACTIVE from "./../assets/images/profileActive.svg"

const LabBottomNavigation = (props) => {

    const [activeRoute,setActiveRoute] = useState(props.location.pathname)
    
    const isActive = (item) => {
        return activeRoute === item.path
    }
    const updateRoute = (item) => {
        setActiveRoute(item.path)
    }
    let items = [
        {
            title : 'سفارش های امروز',
            key : 'today_order',
            icon : TODAY_ORDERS,
            active_icon : TODAY_ORDERS_ACTIVE,
            path: '/panel/dashboard'
        },
        {
            title : 'گزارش سفارش ها',
            key : 'waiting_for_payment',
            icon : ORDERS_REPORTS,
            active_icon : ORDERS_REPORTS_ACTIVE,
            path: '/panel/order-report'
        },
        {
            title : 'گزارش مالی',
            key : 'prepare_prescription',
            icon : FINANCIAL_REPORTS,
            active_icon : FINANCIAL_REPORTS_ACTIVE,
            path: '/panel/financial-report'
        },
        {
            title : 'حساب شما',
            key : 'biker_in_route',
            icon : PROFILE,
            active_icon : PROFILE_ACTIVE,
            path: '/panel/profile'
        }
    ];
    return (
        <>
            <div className="bottom-navigation-holder">
                {
                    items.map((item, index) => {
                        return (
                            // <div className={'bottom-navigation-item-holder ' + (item.key === pharmacy_active_tile ? "active" : "")} key={index} onClick={() => {
                            //     dispatch(setPharmacyActiveTile(item.key))
                            //     dispatch(getPharmacyOrders());
                            // }}>
                            <Link className={"bottom-navigation-item-holder "+(isActive(item) ? "active" : "")} to={item.path} onClick={() => updateRoute(item)} path={item.path}> 
                                <div className="icon-holder">
                                    <img src={ isActive(item) ? item.active_icon : item.icon } width={24} height={24}  alt="bottom-navigation-icon"/>
                                </div>
                                <div className='title'>
                                    {item.title}
                                </div>
                            </Link>
                            // </div>
                            
                        )
                    })
                }
            </div>
        </>
    )
};

export default LabBottomNavigation;